import React, { useState } from "react";
import emailjs from "@emailjs/browser";

const OfferForm = ({ services = [] }) => {
  const [formData, setFormData] = useState({
    from_name: "",
    phone: "",
    from_email: "",
    service: "",
    message: "",
  });

  const [formStatus, setFormStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setFormStatus(null);

    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      phone: formData.phone,
      service: formData.service,
      message: formData.message,
    };

    emailjs.sendForm(
  "service_95zhqfp",
  "template_zndy8a5",
  e.target, // ✅ Doğru: sendForm form DOM'u alır
  "yQ6CrqMr3xNkN1kQH"
)
    
      .then((response) => {
        setFormStatus({
          type: "success",
          message: "Mesaj başarıyla gönderildi!",
        });
        setFormData({
          from_name: "",
          phone: "",
          from_email: "",
          service: "",
          message: "",
        });
      })
      .catch((error) => {
        console.error("EmailJS gönderim hatası:", error); // ← bunu ekle
        setFormStatus({
          type: "error",
          message: "Mesaj gönderilirken bir hata oluştu.",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <label className="block text-gray-700 font-semibold mb-2">Ad Soyad *</label>
        <input
          type="text"
          name="from_name"
          value={formData.name}
          onChange={handleChange}
          required
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Adınız ve soyadınız"
        />
      </div>

      <div>
        <label className="block text-gray-700 font-semibold mb-2">Telefon *</label>
        <input
          type="tel"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          required
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="0551 368 30 20"
        />
      </div>

      <div>
        <label className="block text-gray-700 font-semibold mb-2">E-posta *</label>
        <input
          type="email"
          name="from_email"
          value={formData.email}
          onChange={handleChange}
          required
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="ornek@email.com"
        />
      </div>

      <div>
        <label className="block text-gray-700 font-semibold mb-2">Hizmet Seçin *</label>
        <select
          name="service"
          value={formData.service}
          onChange={handleChange}
          required
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Hizmet seçiniz...</option>
          {services.map((service) => (
            <option key={service.id} value={service.title || service.id}>
              {service.title || service.id}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="block text-gray-700 font-semibold mb-2">Mesajınız</label>
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          rows="4"
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="İhtiyaçlarınızı detaylı yazabilirsiniz..."
        ></textarea>
      </div>

      {formStatus && (
        <div
          className={`p-4 rounded-lg ${
            formStatus.type === "success"
              ? "bg-green-100 text-green-800 border border-green-300"
              : "bg-red-100 text-red-800 border border-red-300"
          }`}
        >
          {formStatus.message}
        </div>
      )}

      <button
        type="submit"
        disabled={loading}
        className={`w-full py-4 rounded-lg font-bold text-lg transition ${
          loading
            ? "bg-gray-400 cursor-not-allowed"
            : "bg-yellow-400 text-blue-900 hover:bg-yellow-500"
        }`}
      >
        {loading ? "Gönderiliyor..." : "Teklif Talebi Gönder"}
      </button>
    </form>
  );
};

export default OfferForm;